import { Form, Input, Select, Cascader, Button, Collapse, Divider, Badge, Upload } from 'antd';
import { useState, useEffect } from 'react';
import { DownOutlined, UserOutlined, GlobalOutlined, ToolOutlined, TeamOutlined, BankOutlined, DollarOutlined, MailOutlined, UploadOutlined, FundOutlined, CalendarOutlined } from '@ant-design/icons';
import departmentKeywords from '../data/departmentKeywords.json';
import companyOptions from '../data/companyOptions.json';
import industryOptions from '../data/industryOptions.json';
import seniorityOptions from '../data/seniorityOptions.json';
import technologyOptions from '../data/technologyOptions.json';
import titleOptions from '../data/titleOptions.json';
import regionCountryOptions from '../data/regionCountryOptions.json';
import employeeCountOptions from '../data/employeeCountOptions.json';
import revenueOptions from '../data/revenueOptions.json';
import fundingOptions from '../data/fundingOptions.json';
import Papa from 'papaparse';

const { Option } = Select;
const { Panel } = Collapse;

const role = sessionStorage.getItem('role'); // Assuming role is stored in sessionStorage

export default function LeadsFilter({ form, handleFilter, handleReset, initialValues }) {
  // State for toggling UI bits
  const [typeOpen, setTypeOpen] = useState("both");
  const [emailStatusAdmin, setEmailStatusAdmin] = useState("all");
  const [showExcludeCountry, setShowExcludeCountry] = useState(false);
  const [showExcludeCompanyLocation, setShowExcludeCompanyLocation] = useState(false);
  const [jobTitles, setJobTitles] = useState([]);
  const [excludedJobTitles, setExcludedJobTitles] = useState([]);
  const [showCustomEmployeeCount, setShowCustomEmployeeCount] = useState(false);
  const [minEmployeeCount, setMinEmployeeCount] = useState(null);
  const [maxEmployeeCount, setMaxEmployeeCount] = useState(null);
  const [showExcludeCompany, setShowExcludeCompany] = useState(false);
  const [showCustomRevenue, setShowCustomRevenue] = useState(false);
  const [showCustomFoundingYear, setShowCustomFoundingYear] = useState(false);
  const [minRevenue, setMinRevenue] = useState(null);
  const [maxRevenue, setMaxRevenue] = useState(null);
  const [minFoundingYear, setMinFoundingYear] = useState(null);
  const [maxFoundingYear, setMaxFoundingYear] = useState(null);
  const [showExcludeIndustry, setShowExcludeIndustry] = useState(false);

  useEffect(() => {
  if (showCustomEmployeeCount && minEmployeeCount && maxEmployeeCount) {
    
    form.setFieldsValue({
      includeemployeeCount_leads: [`${minEmployeeCount}-${maxEmployeeCount}`], // this is your expected format
    });
  } else if (showCustomEmployeeCount && (!minEmployeeCount || !maxEmployeeCount)) {
    form.setFieldsValue({
      includeemployeeCount_leads: [],
    });
  }

  if (showCustomFoundingYear && minFoundingYear && maxFoundingYear) {
    form.setFieldsValue({
      foundingYearOptions_leads: [`${minFoundingYear}-${maxFoundingYear}`],
    });
  } else if (showCustomFoundingYear && (!minFoundingYear || !maxFoundingYear)) {
    form.setFieldsValue({
      foundingYearOptions_leads: [],
    });
  }

  if(showCustomRevenue && minRevenue && maxRevenue){

   
    
    form.setFieldsValue({
      includeRevenue_leads: [`${minRevenue}-${maxRevenue}`],
    });
  } else if (showCustomRevenue && (!minRevenue || !maxRevenue)) {
    form.setFieldsValue({
      includeRevenue_leads: [],
    });
  }

   form.validateFields()
    .then((values) => {
      console.log("Final values:", values);
     
    })
    .catch(console.log);
  
  // else don't touch the field, let the normal select logic work
}, [showCustomFoundingYear, minFoundingYear, maxFoundingYear,showCustomEmployeeCount, minEmployeeCount, maxEmployeeCount,showCustomRevenue, minRevenue, maxRevenue, form]);


  // --- Live Watch for Badge Counts ---
  const includeIndustry = Form.useWatch('includeIndustry_leads', form) || [];
  const employeeCount = Form.useWatch('includeemployeeCount_leads', form) || [];
const customEmployeeCount = (
  showCustomEmployeeCount && minEmployeeCount && maxEmployeeCount
    ? [`${minEmployeeCount}-${maxEmployeeCount}`]
    : []
);

  const revenue = Form.useWatch('includeRevenue_leads', form) || [];
  const customRevenue = showCustomRevenue && minRevenue && maxRevenue ? [`${minRevenue}-${maxRevenue}`] : [];
  const foundingYear = Form.useWatch('foundingYearOptions_leads', form) || [];
  const customFoundingYear = showCustomFoundingYear && minFoundingYear && maxFoundingYear ? [`${minFoundingYear}-${maxFoundingYear}`] : [];
  const includePersonalCountry_leads = Form.useWatch('includePersonalCountry_leads', form) || [];
  const excludePersonalCountry_leads = Form.useWatch('excludePersonalCountry_leads', form) || [];
  const includecompanyLocation_leads = Form.useWatch('includecompanyLocation_leads', form) || [];
  const excludeCompanyLocation_leads = Form.useWatch('excludeCompanyLocation_leads', form) || [];
 
  
  const jobTitlesField = Form.useWatch('includejobTitles_leads', form) || [];
  const technology = Form.useWatch('technology', form) || [];
  const includeCompany = Form.useWatch('includeCompany_leads', form) || [];
  const emailStatus = Form.useWatch('emailStatus', form) || null;
  const funding = Form.useWatch('funding_leads', form) || [];
  // ----- End Live Watch -----

  // --- UI Handlers ---
  const handleDepartmentKeywordChange = () => {};
  // Helper: recursively get all leaf paths
// regionCountryOptions: your Cascader options tree

// Helper: get all leaf paths for a given node




  const handleExcludeCountryChange = () => {};
  const handleExcludeCompanyLocationChange = () => {};
  const handleJobTitleChange = (value) => { console.log(value); setJobTitles(value); };
  const handleExcludedJobTitleChange = (value) => { setExcludedJobTitles(value); };
  const toggleCustomEmployeeCount = () => {
  setShowCustomEmployeeCount(current => {
    const next = !current;
    if (next) {
      // switching to custom: clear default field
      form.setFieldsValue({ includeemployeeCount_leads: [] });
    } else {
      // switching back: clear custom state
      setMinEmployeeCount(null);
      setMaxEmployeeCount(null);
      form.setFieldsValue({ includeemployeeCount_leads: [] }); // optional: or restore last select
    }
    return next;
  });
};
  const toggleCustomFoundingYear = () => {
  setShowCustomFoundingYear(current => {
    const next = !current;
    if (next) {
      form.setFieldsValue({ foundingYearOptions_leads: [] });
    } else {
      setMinFoundingYear(null);
      setMaxFoundingYear(null);
      form.setFieldsValue({ foundingYearOptions_leads: [] });
    }
    return next;
  });
};

const toggleCustomRevenue = () => {
  setShowCustomRevenue(current => {
    const next = !current;
    if (next) {
      form.setFieldsValue({ includeRevenue_leads: [] });
    } else {
      setMinRevenue(null);
      setMaxRevenue(null);
      form.setFieldsValue({ includeRevenue_leads: [] });
    }
    return next;
  });
};
  const handleMinEmployeeCountChange = (e) => { setMinEmployeeCount(e.target.value); };
  const handleMaxEmployeeCountChange = (e) => { setMaxEmployeeCount(e.target.value); };
  
  const handleMinRevenueChange = (e) => { setMinRevenue(e.target.value); };
  const handleMaxRevenueChange = (e) => { setMaxRevenue(e.target.value); };
  const handleMinFoundingYearChange = (e) => { setMinFoundingYear(e.target.value); };
  const handleMaxFoundingYearChange = (e) => { setMaxFoundingYear(e.target.value); };

  // --- CSV Upload ---
  const handleCSVUpload = (file, fieldName) => {
    Papa.parse(file, {
      complete: (result) => {
        const formattedCompanies = result.data.flat().map((company) => company.trim()).filter((company) => company.length > 0);
        const currentValues = form.getFieldValue(fieldName) || [];
        form.setFieldsValue({
          [fieldName]: [...new Set([...currentValues, ...formattedCompanies])],
        });
      },
    });
    return false;
  };

  // --- Form submit ---
  const onFinish = (values) => {
    // ... unchanged (same as yours)
    // code block omitted for brevity
    // [Place your onFinish implementation here, it's unchanged for filtering]
    // ...
    
    handleFilter(values); // In your real code, replace with the actual filtered logic as you had it.
  };

  // Find node in options tree based on a path
// --- Helpers (define once) ---
const findNodeByPath = (options, path) => {
  let node = null;
  let current = options;
  for (let i = 0; i < path.length; i++) {
    node = current.find(opt => opt.value === path[i]);
    if (!node) return null;
    current = node.children || [];
  }
  return node;
};

const collectLeafValues = (node) => {
  if (!node.children || node.children.length === 0) {
    return [node.value];
  }
  return node.children.flatMap(collectLeafValues);
};

const expandCascaderFieldToLeaves = (pathsArray, optionsTree) => {
  if (!Array.isArray(pathsArray)) return [];
  const allLeaves = [];
  pathsArray.forEach(path => {
    const node = findNodeByPath(optionsTree, path);
    if (node) {
      if (node.children && node.children.length > 0) {
        allLeaves.push(...collectLeafValues(node));
      } else {
        allLeaves.push(node.value);
      }
    }
  });
  return Array.from(new Set(allLeaves)); // No duplicates
};

// --- Final onSubmitForm ---
const onSubmitForm = () => {
  form.validateFields()
    .then((values) => {
      console.log("Initial values on submit:", values);
      // Expand all relevant location fields to leaves
      values.includePersonalCountry_leads = expandCascaderFieldToLeaves(values.includePersonalCountry_leads, regionCountryOptions);
      values.excludePersonalCountry_leads = expandCascaderFieldToLeaves(values.excludePersonalCountry_leads, regionCountryOptions);
      values.includecompanyLocation_leads = expandCascaderFieldToLeaves(values.includecompanyLocation_leads, regionCountryOptions);
      values.excludeCompanyLocation_leads = expandCascaderFieldToLeaves(values.excludeCompanyLocation_leads, regionCountryOptions);
      values.includedepartmentKeyword_leads = expandCascaderFieldToLeaves(values.includedepartmentKeyword_leads, departmentKeywords);
      values.includetechnology_leads = expandCascaderFieldToLeaves(values.includetechnology_leads, technologyOptions);

      // (Debug) All location values are now leaf arrays
      console.log("Final values (location fields as only leaves):", values);

      onFinish(values);
    })
    .catch((error) => {
      console.log("Validation failed:", error);
    });
};




  // Helper for badge counts (handling custom input toggles)
  const badgeCount = (arr, alt) => (alt && alt.length > 0 ? alt.length : arr.length);

  return (
    <Form form={form} layout="vertical" onFinish={onFinish} >
      <div style={{ height: 'calc(125vh - 300px)', padding: 24, overflowY: 'auto' }}>
        <Form.Item name="search_leads" label="Search in leads">
          <Input placeholder="Enter name of leads" />
        </Form.Item>
        {role === 'admin' && (
          <Form.Item name="typeOpen_leads"  style={{marginBottom:20}}>
                <Select
                  placeholder="Select Type"
                  onChange={(value) => setTypeOpen(value)}
                >
                  <Option value="both">both</Option>
                  <Option value="mobile_phone">mobile</Option>
                  <Option value="email">email</Option>
                </Select>
              </Form.Item>
        )}
        <Collapse className='filter-tabs' style={{marginBottom:20}} expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />} >
          <Panel header="Industry" key="0" 
            extra={<Badge count={includeIndustry.length} offset={[10, 0]}><BankOutlined /></Badge>}>
            {/* ... unchanged fields ... */}
            
            <Form.Item name="includeIndustry_leads" label="Industry" style={{marginBottom:5}}>
              <Select
                placeholder="Select Industry"
                mode="multiple"
                showSearch
                optionFilterProp="children"
              >
                {industryOptions[0].options.map(opt => (
                  <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                ))}
              </Select>
            </Form.Item>
            <Button type="link" style={{ padding: 0, marginBottom: 5 }} onClick={() => setShowExcludeIndustry(!showExcludeIndustry)}>
              {showExcludeIndustry ? 'Hide Exclude Industry' : 'Show Exclude Industry'}
            </Button>
            {showExcludeIndustry && (
              <Form.Item name="excludeIndustry_leads" label="Exclude Industry">
                <Select
                className="company-select-scroll"
                  placeholder="Select Industry to Exclude"
                  mode="multiple"
                  showSearch
                  optionFilterProp="children"
                >
                  {industryOptions[0].options.map(opt => (
                    <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            )}
          </Panel>
          <Panel header="Employee Count" key="1" 
            extra={
              <Badge count={badgeCount(employeeCount, customEmployeeCount)} offset={[10, 0]}>
                <TeamOutlined />
              </Badge>
            }>
            {!showCustomEmployeeCount && (
              <Form.Item name="includeemployeeCount_leads" style={{marginBottom:0}} label="Employee Count">
                <Select
                  placeholder="Select Employee Count"
                  mode="multiple"
                  showSearch
                  optionFilterProp="children"
                >
                  {employeeCountOptions.options.map(opt => (
                    <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            )}
            {showCustomEmployeeCount && (
              <Form.Item name="includeemployeeCount_leads" style={{marginBottom:0}} label="Custom Employee Count Range">
                <Input.Group compact>
                  <Input style={{ width: '50%' }} placeholder="Min" onChange={handleMinEmployeeCountChange} />
                  <Input style={{ width: '50%' }} placeholder="Max" onChange={handleMaxEmployeeCountChange} />
                </Input.Group>
              </Form.Item>
            )}
            <Button type="link" onClick={toggleCustomEmployeeCount} style={{ marginTop: 5, padding: 0, marginBottom:10 }}>
              {showCustomEmployeeCount ? 'Hide Custom Employee Count' : 'Show Custom Employee Count'}
            </Button>
          </Panel>
          <Panel header="Revenue" key="2"
            extra={
              <Badge count={badgeCount(revenue, customRevenue)} offset={[10, 0]}>
                <DollarOutlined />
              </Badge>
            }>
            {!showCustomRevenue && (
              <Form.Item name="includeRevenue_leads" style={{marginBottom:0}} label="Revenue">
                <Select
                  placeholder="Select Revenue"
                  mode="multiple"
                  showSearch
                  optionFilterProp="children"
                >
                  {revenueOptions.options.map(opt => (
                    <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            )}
            {showCustomRevenue && (
              <Form.Item name="includeRevenue_leads" style={{marginBottom:0}} label="Custom Revenue Range">
                <Input.Group compact>
                  <Input style={{ width: '50%' }} placeholder="Min" onChange={handleMinRevenueChange} />
                  <Input style={{ width: '50%' }} placeholder="Max" onChange={handleMaxRevenueChange} />
                </Input.Group>
              </Form.Item>
            )}
            <Button type="link" onClick={toggleCustomRevenue} style={{ marginTop: 5, padding: 0, marginBottom:10 }}>
              {showCustomRevenue ? 'Hide Custom Revenue' : 'Show Custom Revenue'}
            </Button>
          </Panel>
          <Panel header="Founding Year" key="10"
            extra={
              <Badge count={badgeCount(foundingYear, customFoundingYear)} offset={[10, 0]}>
                <CalendarOutlined />
              </Badge>
            }>
            {!showCustomFoundingYear && (
              <Form.Item name="foundingYearOptions_leads" style={{marginBottom:0}} label="Founding Year">
                <Select
                  placeholder="Select Founding Year"
                  mode="multiple"
                  showSearch
                  optionFilterProp="children"
                >
                  {Array.from({ length: new Date().getFullYear() - 1900 + 1 }, (_, i) => 1900 + i).map(year => (
                    <Option key={year} value={year}>{year}</Option>
                  ))}
                </Select>
              </Form.Item>
            )}
            {showCustomFoundingYear && (
              <Form.Item name="foundingYearOptions_leads" style={{marginBottom:0}} label="Custom Founding Year Range">
                <Input.Group compact>
                  <Input style={{ width: '50%' }} placeholder="Min" onChange={handleMinFoundingYearChange} />
                  <Input style={{ width: '50%' }} placeholder="Max" onChange={handleMaxFoundingYearChange} />
                </Input.Group>
              </Form.Item>
            )}
            <Button type="link" onClick={toggleCustomFoundingYear} style={{ marginTop: 5, padding: 0, marginBottom:10 }}>
              {showCustomFoundingYear ? 'Hide Custom Founding Year' : 'Show Custom Founding Year'}
            </Button>
          </Panel>
          <Panel header="Location" key="3"
            extra={<Badge count={includePersonalCountry_leads.length+excludePersonalCountry_leads.length+includecompanyLocation_leads.length+excludeCompanyLocation_leads.length} offset={[10, 0]}><GlobalOutlined /></Badge>}>
            {/* ... unmodified location filter fields ... */}
            <Form.Item name="includePersonalCountry_leads" style={{marginBottom:5}} label="Include Personal Location">
              <Cascader
                options={regionCountryOptions}           
                placeholder="Select Location"
                multiple
                showSearch
                maxTagCount="responsive"
                
              />
            </Form.Item>
            <Button type="link" style={{ padding: 0,marginBottom:5 }} onClick={() => setShowExcludeCountry(!showExcludeCountry)}>
              {showExcludeCountry ? 'Hide Exclude Personal Location' : 'Show Exclude Personal Location'} 
            </Button>
            {showExcludeCountry && (
              <Form.Item name="excludePersonalCountry_leads" label="Exclude Personal Location">
                <Cascader
                  options={regionCountryOptions}
                  placeholder="Select Location to Exclude"
                  multiple
                  showSearch
                  maxTagCount="responsive"
                  onChange={handleExcludeCountryChange}
                />
              </Form.Item>
            )}
            <Divider style={{background:"#a2a2a2",margin:"10px 0px"}} />
            <Form.Item name="includecompanyLocation_leads" style={{marginBottom:5,marginTop:15}} label="Company Location">
              <Cascader
                options={regionCountryOptions}
                placeholder="Select Company Location"
                multiple
                showSearch
                maxTagCount="responsive"
              />
            </Form.Item>
            <Button type="link" style={{ padding: 0,marginBottom:5 }} onClick={() => setShowExcludeCompanyLocation(!showExcludeCompanyLocation)}>
              {showExcludeCompanyLocation ? 'Hide Exclude Company Location' : 'Show Exclude Company Location'} 
            </Button>
            {showExcludeCompanyLocation && (
              <Form.Item name="excludeCompanyLocation_leads" label="Exclude Company Location">
                <Cascader
                  options={regionCountryOptions}
                  placeholder="Select Company Location to Exclude"
                  multiple
                  showSearch
                  maxTagCount="responsive"
                  onChange={handleExcludeCompanyLocationChange}
                />
              </Form.Item>
            )}
          </Panel>
          <Panel header="Title/Role" key="4"
            extra={<Badge count={jobTitlesField.length} offset={[10, 0]}><UserOutlined /></Badge>}>
            {/* ... unchanged ... */}
            <Form.Item name="includejobTitles_leads" label="Job Titles">
              <Select
                mode="tags"
                placeholder="Enter job titles and press enter"
                onChange={handleJobTitleChange}
                tokenSeparators={[',']}
                options={titleOptions.options}
              />
            </Form.Item>
            <Form.Item name="excludedJobTitles_leads" label="Excluded Job Titles">
              <Select
                mode="tags"
                placeholder="Enter job titles to exclude and press enter"
                onChange={handleExcludedJobTitleChange}
                tokenSeparators={[',']}
                options={titleOptions.options}
              />
            </Form.Item>
            <Form.Item name="includemanagmentRole_leads" label="Management Level">
              <Select
                placeholder="Select Title"
                mode="multiple"
                showSearch
                optionFilterProp="children"
              >
                {seniorityOptions.options.map(opt => (
                  <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="includedepartmentKeyword_leads" label="Department & Keywords">
              <Cascader
                options={departmentKeywords}
                placeholder="Select Department"
                multiple
                showSearch
                maxTagCount="responsive"
                onChange={handleDepartmentKeywordChange}
              />
            </Form.Item>
          </Panel>
          <Panel header="Technology" key="5"
            extra={<Badge count={technology.length} offset={[10, 0]}><ToolOutlined /></Badge>}>
            <Form.Item name="includetechnology_leads" label="Technology">
              <Cascader
                options={technologyOptions}
                placeholder="Select Technology"
                multiple
                showSearch
                maxTagCount="responsive"
              />
            </Form.Item>
          </Panel>
          <Panel header="Company name / Domain" key="6"
            extra={<Badge count={includeCompany.length} offset={[10, 0]}><BankOutlined /></Badge>}>
            <Form.Item style={{marginBottom:5}} name="includeCompany_leads" label="Include Company">
              <Select
  mode="tags"
  className="company-select-scroll"
  placeholder="Enter company names or paste from Excel"
  tokenSeparators={[',']}
  value={form.getFieldValue('includeCompany_leads')}
  onPaste={e => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('Text');
    const formattedCompanies = pastedText
      .split(/[\t\n\r]+/)
      .map((company) => company.trim())
      .filter((company) => company.length > 0);
    const currentValues = form.getFieldValue('includeCompany_leads') || [];
    form.setFieldsValue({
      includeCompany_leads: [...new Set([...currentValues, ...formattedCompanies])],
    });
  }}
/>
            </Form.Item>
            <div style={{marginTop:5}}>
              <Upload beforeUpload={(file) => handleCSVUpload(file, 'includeCompany_leads')} showUploadList={false}>
                <Button icon={<UploadOutlined />}>Upload CSV</Button>
              </Upload>
            </div>
            <Button type="link" style={{ padding: 0, marginBottom: 5 }} onClick={() => setShowExcludeCompany(!showExcludeCompany)}>
              {showExcludeCompany ? 'Hide Exclude Company' : 'Show Exclude Company'}
            </Button>
            {showExcludeCompany && (
              <>
              <Form.Item style={{marginBottom:5}} name="excludeCompany_leads" label="Exclude Company">
                <Select
                  mode="tags"
                  placeholder="Enter company names or paste from Excel"
                  tokenSeparators={[',']}
                  onPaste={e => {
                    e.preventDefault();
                    const pastedText = e.clipboardData.getData('Text');
                    const formattedCompanies = pastedText
                      .split(/[\t\n\r]+/)
                      .map((company) => company.trim())
                      .filter((company) => company.length > 0);
                    const currentValues = form.getFieldValue('excludeCompany_leads') || [];
                    form.setFieldsValue({
                      excludeCompany_leads: [...new Set([...currentValues, ...formattedCompanies])],
                    });
                  }}
                />
              </Form.Item>
              <div style={{marginTop:5}}>
                <Upload beforeUpload={(file) => handleCSVUpload(file, 'excludeCompany_leads')} showUploadList={false}>
                  <Button icon={<UploadOutlined />}>Upload CSV</Button>
                </Upload>
              </div>
              </>
            )}
          </Panel>
          <Panel header="Email Status" key="7"
            extra={<Badge count={emailStatus ? 1 : 0} offset={[10, 0]}><MailOutlined /></Badge>}>
            <Form.Item name="emailStatus_leads" label="Email Status">
              <Select
                placeholder="Select Email Status"
                showSearch
                optionFilterProp="children"
              >
                <Option value="verified">Verified</Option>
                <Option value="unverified">Unverified</Option>
              </Select>
            </Form.Item>

            {role === 'admin' && (
              <Form.Item name="emailStatusAdmin_leads" label="Original Email Status">
                <Select
                  placeholder="Select Email Status"
                  showSearch
                  optionFilterProp="children"
                >
                  <Option value="all">All</Option>
                  <Option value="valid">valid</Option>
                  <Option value="invalid">invalid</Option>
                  <Option value="risky">risky</Option>
                  <Option value="unknown">unknown</Option>
                </Select>
              </Form.Item>
            )}
          </Panel>
          <Panel header="Funding" key="8"
            extra={<Badge count={funding.length} offset={[10, 0]}><FundOutlined /></Badge>}>
            <Form.Item name="funding_leads" label="Funding">
              <Select
                placeholder="Select Funding"
                mode="multiple"
                showSearch
                optionFilterProp="children"
                options={fundingOptions.options}
              />
            </Form.Item>
          </Panel>
        </Collapse>
      </div>
      <div style={{ padding: 20, borderTop: '1px solid #f0f0f0', display: 'flex', gap: '10px' }}>
        <Form.Item style={{ marginBottom: 0, flex: 1 }}>
          <Button type="primary" onClick={onSubmitForm} block> Find leads</Button>
        </Form.Item>
        <Form.Item style={{ marginBottom: 0, flex: 1 }}>
          <Button type="default" onClick={handleReset} block>Reset Filter</Button>
        </Form.Item>
      </div>
    </Form>
  );
}
